module.exports = __webpack_public_path__ + "static/img/ic_bottom_home_on@2x.bec59b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_home_on@2x.png
// module id = md67
// module chunks = 1